// ======================= screens: ==========================
import {
  bank_account, keyboardImagesNames,
  ManualName,
  receipt,
  select_package_configuration_key,
} from '../../utils/DictionaryManagementUtils';

export default function screensGoConfigFlow(configuration, service) {
  const screens = [];
  service.screens_ordering.forEach((step) => {
    getScreenByStepKey[step](screens, service[step], configuration);
  });
  return screens;
}

const selectRecipientScreen = (add_recipient_manually, show_avatar_in_contact_lists, skip_contact_list_when_empty, contact_image) => {
  const selectRecipient = {
    name: 'selectRecipient',
    template: 'selectRecipient001',
    imageElements: [],
    buttonElements: [],
    listElements: [],
  };
  if (skip_contact_list_when_empty) {
    selectRecipient.isSkippable = true;
  }

  // image1 - gives images asset to show error, when search has no results
  selectRecipient.imageElements.push({
    name: 'image1',
    asset: keyboardImagesNames.ic_no_results,
  });

  if (add_recipient_manually) {
    // button1 - navigates to manual input
    selectRecipient.buttonElements.push({
      name: 'button1',
      asset: contact_image === 'plus_sign'
        ? keyboardImagesNames.wls_ic_add_recipient_plus
        : keyboardImagesNames.wls_ic_add_recipient_contact,
      actionPath: 'manualInputPath',
    });
  } else {
    delete selectRecipient.buttonElements;
  }
  selectRecipient.listElements.push({
    name: 'list1',
    cellElements: [
      {
        // cell1 - navigates to next step in a flow
        name: 'cell1',
        template: show_avatar_in_contact_lists
          //  recipientCell001 - cells with avatars
          ? 'recipientCell001'
          // recipientCell002 - cells without avatars
          : 'recipientCell002',
        actionPath: 'selectRecipientPath',
      },
    ],
  });
  return selectRecipient;
};

const amountPerParticipantScreen = (show_avatar_in_contact_lists) => {
  const amountPerParticipant = {
    name: 'amountPerParticipant',
    template: 'amountPerParticipant001',
    imageElements: [],
    buttonElements: [],
    listElements: [],
  };
  amountPerParticipant.imageElements.push({
    name: 'image1',
    asset: keyboardImagesNames.ic_no_results,
  });
  amountPerParticipant.listElements.push({
    name: 'list1',
    cellElements: [
      {
        name: 'cell1',
        template: show_avatar_in_contact_lists
          ? 'recipientCellMultiple001'
          : 'recipientCellMultiple002',
        actionPath: 'selectRecipientMultiplePath',
      },
    ],
  });
  return amountPerParticipant;
};

const selectRecipientMultipleScreen = (add_recipient_manually, show_avatar_in_contact_lists, skip_contact_list_when_empty) => {
  const selectRecipientMultiple = {
    name: 'selectRecipientMultiple',
    template: 'selectRecipientMultiple001',
    imageElements: [],
    buttonElements: [],
    listElements: [],
  };
  if (skip_contact_list_when_empty) {
    selectRecipientMultiple.isSkippable = true;
  }
  // image1 - gives images asset to show error, when search has no results
  selectRecipientMultiple.imageElements.push({
    name: 'image1',
    asset: keyboardImagesNames.ic_no_results,
  });

  if (add_recipient_manually) {
    // button1 - navigates to manual input
    selectRecipientMultiple.buttonElements.push({
      name: 'button1',
      actionPath: 'manualInputPathSplit',
    });
  } else {
    delete selectRecipientMultiple.buttonElements;
  }
  selectRecipientMultiple.listElements.push({
    name: 'list1',
    cellElements: [
      {
        // cell1 - navigates to next step in a flow
        name: 'cell1',
        template: show_avatar_in_contact_lists
          //  recipientCellMultiple001 - cells with avatars
          ? 'recipientCellMultiple001'
          // recipientCellMultiple002 - cells without avatars
          : 'recipientCellMultiple002',
        actionPath: 'selectRecipientMultiplePath',
      },
    ],
  });
  return selectRecipientMultiple;
};

const selectPaymentMethodScreen = (recipient) => {
  const selectPaymentMethod = {
    name: 'selectPaymentMethod',
    template: 'selectPaymentMethod001',
    collectionElements: [],
  };

  recipient.screens_ordering.filter((manual_name) => recipient.manual_recipients[manual_name].selected)
    .forEach((manual_name, index) => {
      selectPaymentMethod.collectionElements.push([
        {
          name: `view${index}`,
          actionPath: `${ManualName[manual_name]}Path`,
          template: 'paymentMethodItem001',
        },
      ]);
    });

  return selectPaymentMethod;
};

const addManuelRecipientInputScreen = (screens, manual_recipient, manual_category, is_arrow_icon) => {
  const inputItem = {
    name: `${ManualName[manual_category]}Input`,
    template: `${ManualName[manual_category]}Input001`,
    inputElements: [],
    checkElements: [],
    buttonElements: [],
  };

  if (manual_recipient.save_to_list) {
    // check1 - show/hide checkbox “save to contacts”
    inputItem.checkElements.push({ name: 'check1' });
    if (manual_recipient.add_contact_name) {
      // input100 - show/hide save-to-contact name input
      // (can be visible only if check1 is present and is “checked” by the user)
      inputItem.inputElements.push({ name: 'input100' });
    }
  }
  if (manual_recipient.enable_recipient_validation) {
    // button1 - show/hide verify button
    inputItem.buttonElements.push({
      name: 'button1',
      asset: is_arrow_icon
        ? keyboardImagesNames.wls_ic_search_arrow
        : keyboardImagesNames.wls_ic_search_magnify,
    });
  }
  if (manual_recipient.manual_fields_list.recipient_name) {
    // input1 - show/hide Name input
    inputItem.inputElements.push({ name: 'input1' });
  }
  if (manual_recipient.manual_fields_list.recipient_id) {
    // input2 - show/hide Id input
    inputItem.inputElements.push({ name: 'input2' });
  }

  if (inputItem.inputElements.length === 0) {
    delete inputItem.inputElements;
  }
  if (inputItem.checkElements.length === 0) {
    delete inputItem.checkElements;
  }
  if (inputItem.buttonElements.length === 0) {
    delete inputItem.buttonElements;
  }
  screens.push(inputItem);
};

const addAccountNumberInputScreens = (screens, manual_recipient, is_arrow_icon) => {
  const accountNumberInput = {
    name: `${ManualName[bank_account]}Input`,
    template: `${ManualName[bank_account]}Input001`,
    inputElements: [],
    checkElements: [],
    buttonElements: [],
  };

  if (manual_recipient.save_to_list) {
    // check1 - show/hide checkbox “save to contacts”
    accountNumberInput.checkElements.push({ name: 'check1' });
    if (manual_recipient.add_contact_name) {
      // input100 - show/hide save-to-contact name input
      // (can be visible only if check1 is present and is “checked” by the user)
      accountNumberInput.inputElements.push({ name: 'input100' });
    }
  }
  if (manual_recipient.manual_fields_list.recipient_id) {
    // input1 - show/hide Id input
    accountNumberInput.inputElements.push({ name: 'input1' });
  }
  if (manual_recipient.manual_fields_list.recipient_name) {
    // input2 - show/hide Name input
    accountNumberInput.inputElements.push({ name: 'input2' });
  }
  if (manual_recipient.manual_fields_list.manual_name) {
    // input5 - show/hide Number input
    accountNumberInput.inputElements.push({ name: 'input5' });
  }
  if (manual_recipient.manual_fields_list.bank) {
    if (manual_recipient.search_from_list_bank) {
      // button1 - show/hide Bank button + navigation
      accountNumberInput.buttonElements.push({
        name: 'button1',
        actionPath: 'manualInputSelectBankPath',
      });
      screens.push(selectAccountBankScreen());
    } else {
      // input3 - show/hide Bank input
      accountNumberInput.inputElements.push({ name: 'input3' });
    }
  }
  if (manual_recipient.manual_fields_list.branch_name) {
    if (manual_recipient.search_from_list_branch_name) {
      // button2 - show/hide Branch button  + navigation
      accountNumberInput.buttonElements.push({
        name: 'button2',
        actionPath: 'manualInputSelectBranchPath',
      });
      screens.push(selectAccountBranchScreen());
    } else {
      // input4 - show/hide Branch input
      accountNumberInput.inputElements.push({ name: 'input4' });
    }
  }
  // button3 - navigation to next screen in the flow
  accountNumberInput.buttonElements.push({
    name: 'button3',
    actionPath: 'manualInputAmountPath',
  });
  if (manual_recipient.enable_recipient_validation) {
    // button4 - show/hide validation button. Possible to show only when 1 input is visible!
    accountNumberInput.buttonElements.push({
      name: 'button4',
      asset: is_arrow_icon
        ? keyboardImagesNames.wls_ic_search_arrow
        : keyboardImagesNames.wls_ic_search_magnify,
    });
  }

  if (accountNumberInput.inputElements.length === 0) {
    delete accountNumberInput.inputElements;
  }
  if (accountNumberInput.checkElements.length === 0) {
    delete accountNumberInput.checkElements;
  }
  if (accountNumberInput.buttonElements.length === 0) {
    delete accountNumberInput.buttonElements;
  }
  screens.push(accountNumberInput);
};

export const selectAccountBankScreen = () => {
  const selectAccountBank = {
    name: 'selectAccountBank',
    template: 'selectAccountBank001',
    listElements: [],
  };
  // --- listElements:
  selectAccountBank.listElements.push({
    name: 'list1',
    cellElements: [
      {
        name: 'cell1',
        template: 'accountBankCell001',
      },
    ],
  });
  return selectAccountBank;
};

export const selectAccountBranchScreen = () => {
  const selectAccountBranch = {
    name: 'selectAccountBranch',
    template: 'selectAccountBranch001',
    listElements: [],
  };
  // --- listElements:
  selectAccountBranch.listElements.push({
    name: 'list1',
    cellElements: [
      {
        name: 'cell1',
        template: 'accountBranchCell001',
      },
    ],
  });
  return selectAccountBranch;
};

export const addSelectRecipientScreens = (screens, screenConfiguration, configuration) => {
  const isMultipleRecipient = screenConfiguration.is_multiple_recipient;
  if (screenConfiguration.select_from_recipients_list) {
    if (isMultipleRecipient) {
      screens.push(selectRecipientMultipleScreen(screenConfiguration.add_recipient_manually, configuration.general.show_avatar_in_contact_lists,
        screenConfiguration.skip_contact_list_when_empty));
      screens.push(amountPerParticipantScreen(configuration.general.show_avatar_in_contact_lists));
    } else {
      screens.push(selectRecipientScreen(screenConfiguration.add_recipient_manually, configuration.general.show_avatar_in_contact_lists,
        screenConfiguration.skip_contact_list_when_empty, screenConfiguration.contact_image));
    }
  }
  if (screenConfiguration.add_recipient_manually) {
    if (screenConfiguration.screens_ordering
      .filter((manual_name) => screenConfiguration.manual_recipients[manual_name].selected).length > 1) {
      screens.push(selectPaymentMethodScreen(screenConfiguration));
    }
    screenConfiguration.screens_ordering
      .filter((manual_name) => screenConfiguration.manual_recipients[manual_name].selected)
      .forEach((manual_name) => {
        const manual_recipient = screenConfiguration.manual_recipients[manual_name];
        if (manual_name === bank_account) {
          addAccountNumberInputScreens(screens, manual_recipient, configuration.general.is_arrow_icon);
        } else {
          addManuelRecipientInputScreen(screens, manual_recipient, manual_name, configuration.general.is_arrow_icon);
        }
      });
  }
};

export const addAmountScreens = (screens, screenConfiguration) => {
  const amountInput = {
    name: 'amountInput',
    template: 'amountInput001',
    textElements: [],
    buttonElements: [],
  };
  if (screenConfiguration.show_account_balance) {
    // button1 - show/hide account view. Also navigates to select account screen
    amountInput.buttonElements.push({
      name: 'button1',
      actionPath: 'selectPayingAccountPath',
    });
    screens.push(selectTransactionAccountScreen());
  }
  if (screenConfiguration.enable_additional_instruction) {
    // text1 - show/hide convert text
    amountInput.textElements.push({ name: 'text1' });
    // text2 - show/hide instructions text
    amountInput.textElements.push({ name: 'text2' });
    // text3 - show/hide balance text (maybe removed in future)
    amountInput.textElements.push({ name: 'text3' });
  }
  // button2 - navigates to select currency screen
  if (screenConfiguration.select_currency) {
    amountInput.buttonElements.push({
      name: 'button2',
      actionPath: 'selectTransferCurrencyPath',
    });
    screens.push(selectTransferCurrencyScreen());
  }

  if (amountInput.textElements.length === 0) {
    delete amountInput.textElements;
  }
  screens.push(amountInput);
};

export const addAmountPackageScreens = (screens, screenConfiguration) => {
  const selectPackage = {
    name: 'selectPackage',
    template: 'selectPackage001',
    buttonElements: [],
    listElements: [],
  };
  if (screenConfiguration.package_configuration === select_package_configuration_key.manual_amount) {
    addAmountScreens(screens, screenConfiguration);
    return;
  }
  if (screenConfiguration.package_configuration === select_package_configuration_key.both) {
    addAmountScreens(screens, screenConfiguration);
    // button1 - show/hide manual amount button + navigation to amountInput screen
    selectPackage.buttonElements.push({
      name: 'button1',
      actionPath: 'amountInputPath',
    });
  } else if (screenConfiguration.show_account_balance) {
    screens.push(selectTransactionAccountScreen());
  }
  if (screenConfiguration.show_account_balance) {
    // button2 - show/hide account view + navigation to selectAccount screen
    selectPackage.buttonElements.push({
      name: 'button2',
      actionPath: 'selectPayingAccountPath',
    });
  }

  const templateList = {
    column_1: 'list_001',
    column_2: 'list_002',
    column_3: 'list_003',
  };
  const templateCell = {
    left_aligned: 'packageCell001',
    center_aligned: 'packageCell002',
  };
  selectPackage.listElements.push(
    {
      name: 'list1',
      template: templateList[screenConfiguration.package_layout_columns],
      cellElements: [
        {
          name: 'cell1',
          template: templateCell[screenConfiguration.package_layout_aligned],
        },
      ],
    },
  );
  if (selectPackage.buttonElements.length === 0) {
    delete selectPackage.buttonElements;
  }
  screens.push(selectPackage);
};

export const selectPackageScreens = (screens, screenConfiguration) => {
  if (screenConfiguration.customer_should_select_a_mobile_operator || screenConfiguration.select_loan_installment_options) {
    const selectPackage = {
      name: 'selectPackage',
      isSkippable: false,
      template: 'selectPackage001',
      listElements: [],
    };
    const templateList = {
      column_1: 'list_001',
      column_2: 'list_002',
    };
    const templateCell = {
      left: 'packageCell001',
      center: 'packageCell002',
    };

    selectPackage.listElements.push(
      {
        name: 'list1',
        template: templateList[screenConfiguration.multiple_columns],
        cellElements: [
          {
            name: 'cell1',
            template: templateCell[screenConfiguration.content_aligned_center],
          },
        ],
      },
    );

    screens.push(selectPackage);
  }
};

export const addOperatorScreens = (screens, screenConfiguration) => {
  if (screenConfiguration.customer_should_select_a_mobile_operator) {
    const selectOperator = {
      name: 'selectOperator',
      template: 'selectOperator001',
      listElements: [],
    };
    const templateList = {
      column_1: 'list_001',
      column_2: 'list_002',
    };

    selectOperator.listElements.push(
      {
        name: 'list1',
        template: templateList[screenConfiguration.design_the_layout],
        cellElements: [
          {
            name: 'cell1',
            template: 'operatorCell001',
          },
        ],
      },
    );

    screens.push(selectOperator);
  }
};

export const selectTransferCurrencyScreen = () => ({
  name: 'selectTransferCurrency',
  template: 'selectTransferCurrency001',
  listElements: [
    {
      name: 'list1',
      cellElements: [
        {
          name: 'cell1',
          template: 'currencyCell001',
        },
      ],
    },
  ],
});

export const installmentsNumberInputScreen = (screens) => (
  screens.push({
    name: 'installmentsNumberInput',
    template: 'installmentsNumberInput001',
  }));

export const selectTransactionAccountScreen = (simpleTransactionAccount) => ({
  name: 'selectTransactionAccount',
  template: simpleTransactionAccount ? 'selectTransactionAccount001' : 'selectTransactionAccount002',
  listElements: [{
    name: 'list1',
    cellElements: [{
      name: 'cell1',
      template: 'accountCell001',
    }],
  }],
});

export const addReferenceScreens = (screens, screenConfiguration) => {
  if (screenConfiguration.step_enabled) {
    if (screenConfiguration.customers_add_photo_enabled) {
      screens.push(referenceImageScreen());
    }
    if (screenConfiguration.select_reason_from_options) {
      screens.push(referenceMainScreen(screenConfiguration));
      screens.push(referenceReasonScreen(screenConfiguration.custom_reason));
      if (screenConfiguration.custom_reason) {
        screens.push(referenceCustomReasonScreen(screenConfiguration));
      }
    } else {
      screens.push(referenceCustomReasonScreen(screenConfiguration));
    }
  }
};

export const referenceMainScreen = (screenConfiguration) => {
  const referenceMain = {
    name: 'referenceMain',
    template: 'referenceMain001',
    buttonElements: [{
      name: 'button1',
      actionPath: 'confirmReferencePath',
    }],
    listElements: [],
  };
  if (screenConfiguration.customers_add_photo_enabled) {
    referenceMain.buttonElements.push(
      {
        name: 'button2',
      },
    );
    referenceMain.listElements.push({
      name: 'list1',
      cellElements: [
        {
          name: 'cell1',
          template: 'selectReferenceChooseImageCell001',
          actionPath: 'selectReferenceImagePath',
        },
        {
          name: 'cell2',
          template: 'selectReferenceImageCell001',
        },
      ],
    });
  } else {
    delete referenceMain.listElements;
  }
  return referenceMain;
};

export const referenceReasonScreen = (isCustomReason) => {
  const selectReference = {
    name: 'selectReference',
    template: 'selectReference001',
    listElements: [
      {
        name: 'list1',
        cellElements: [
          {
            // cell1 - navigates to next step, if user selects predefined reference.
            name: 'cell1',
            template: 'referenceCell001',
          },
        ],
      },
    ],
  };

  if (isCustomReason) {
    // cell2 - navigates to referenceInput, if user selects ‘Custom’ item.
    selectReference.listElements[0].cellElements.push({
      name: 'cell2',
      template: 'referenceCell001',
      actionPath: 'referenceInputPath',
    });
  }
  return selectReference;
};

export const referenceImageScreen = () => ({
  name: 'selectReferenceImage',
  template: 'selectReferenceImage001',
  imageElements: [
    {
      name: 'image1',
      asset: keyboardImagesNames.ic_gallery_permission,
    },
  ],
  listElements: [
    {
      name: 'list1',
      cellElements: [
        {
          name: 'cell1',
          template: 'galleryImageCell001',
        },
      ],
    },
  ],
});

export const referenceCustomReasonScreen = (screenConfiguration) => {
  const referenceCustomReason = {
    name: 'referenceInput',
    template: 'referenceInput001',
  };
  if (screenConfiguration.customers_add_photo_enabled) {
    referenceCustomReason.listElements = [{
      name: 'list1',
      cellElements: [
        {
          name: 'cell1',
          template: 'selectReferenceChooseImageCell001',
          actionPath: 'selectReferenceImagePath',
        },
        {
          name: 'cell2',
          template: 'selectReferenceImageCell001',
        },
      ],
    }];
  }
  return referenceCustomReason;
};

export const addConfirmationScreens = (screens, screenConfiguration) => {
  const transferConfirmation = {
    name: 'transferConfirmation',
    template: 'transferConfirmation001',
    checkElements: [],
  };
  if (screenConfiguration.enable_transaction_fee_on_the_recipient) {
    // check1 - show/hide fee checkbox.
    transferConfirmation.checkElements = [{ name: 'check1' }];
  } else {
    delete transferConfirmation.checkElements;
  }

  screens.push(transferConfirmation);
};
export const addAuthenticationScreens = () => {

};
export const addSuccessScreens = (screens, screenConfiguration, configuration) => {
  const transactionSuccess = {
    name: 'transactionSuccess',
    template: 'transactionSuccess001',
    // image1 - provides custom asset for success image.
    imageElements: [{
      name: 'image1',
      asset: keyboardImagesNames.ic_success,
    }],
    buttonElements: [],
  };

  if (screenConfiguration.enable_customer_to_share_transaction) {
    if (screenConfiguration.sharing_method === receipt) {
      // button2 - show/hide “share receipt” button and navigates to receipt screen.
      transactionSuccess.buttonElements.push({
        name: 'button2',
        actionPath: 'receiptPath',
      });
      const transactionReceipt = {
        name: 'transactionReceipt',
        template: 'transactionReceipt001',
      };
      screens.push(transactionReceipt);
    } else {
      // button1 - show/hide “share link” button.
      transactionSuccess.buttonElements.push({
        name: 'button1',
        actionPath: 'receiptPath',
      });
    }
  }
  if (screenConfiguration.enable_customer_to_make_another_transfer) {
    // button3 - navigates to menu screen.
    transactionSuccess.buttonElements.push({
      name: 'button3',
      actionPath: configuration.services.menu.layout_menu_screen ? 'menuPath' : 'defaultPath',
    });
  }

  if (transactionSuccess.buttonElements.length === 0) {
    delete transactionSuccess.buttonElements;
  }
  screens.push(transactionSuccess);
};

export const addSelectBillScreens = (screens, screenConfiguration) => {
  const selectBill = {
    name: 'selectBill',
    template: 'selectBill001',
    isSkippable: true,
    buttonElements: [],
    listElements: [{
      name: 'list1',
      cellElements: [{
        name: 'cell1',
        template: 'billCell001',
        actionPath: 'selectBillPath',
      }],
    }],
  };
  if (screenConfiguration.enable_customer_to_bill_code_manually) {
    // button1 - show/hide ‘insert’ button in toolbar + navigation to barcode screen
    selectBill.buttonElements.push({
      name: 'button1',
      actionPath: 'selectPayBillInputMethodPath',
    });
    // button2 - show/hide ‘insert’ button in the bottom of the screen + navigation to barcode screen
    selectBill.buttonElements.push({
      name: 'button2',
      actionPath: 'selectPayBillInputMethodPath',
    });
    const barcodeInput = {
      name: 'barcodeInput',
      template: 'barcodeInput001',
    };
    screens.push(barcodeInput);
  }
  if (screenConfiguration.show_account_balance) {
    // button3 - show/hide account view + navigation to selectAccount screen
    selectBill.buttonElements.push({
      name: 'button3',
      actionPath: 'selectPayingAccountPath',
    });

    screens.push(selectTransactionAccountScreen());
  }
  screens.push(selectBill);

  const selectMethod = {
    name: 'selectPayBillInputMethod',
    template: 'selectPayBillInputMethod001',
    isSkippable: true,
    buttonElements: [],
    listElements: [{
      name: 'list1',
      cellElements: [{
        name: 'cell1',
        template: 'billCell001',
        actionPath: 'selectBillPath',
      }],
    }],
  };

  if (screenConfiguration.enable_customer_to_bill_code_manually) {
    if (screenConfiguration.enable_customer_to_scan_barcode) {
      // button1 - show/hide scan barcode button
      selectMethod.buttonElements.push({
        name: 'button1',
        actionPath: 'scanBillPath',
      });
    }
    // button2 - show/hide ‘insert’ button in the bottom of the screen + navigation to barcode screen
    selectMethod.buttonElements.push({
      name: 'button2',
      actionPath: 'manualBillPath',
    });
    const barcodeScan = {
      name: 'barcodeScan',
      template: 'barcodeScan001',
    };
    screens.push(barcodeScan);
    screens.push(selectMethod);
  }
};

export const addConfirmationBillScreens = (screens, screenConfiguration) => {
  const billConfirmation = {
    name: 'billConfirmation',
    template: 'billConfirmation001',
    buttonElements: [],
  };

  if (screenConfiguration.allow_customer_to_change_payment_date) {
    // button1 - show/hide calendar button.
    billConfirmation.buttonElements.push({ name: 'button1' });
  } else {
    delete billConfirmation.buttonElements;
  }
  screens.push(billConfirmation);
};

export const addBalanceScreens = (screens) => {
  screens.push(selectTransactionAccountScreen(true));
};

export const addTransactionsScreens = (screens, screenConfiguration) => {
  screens.push(accountTransactionsScreen());
  if (screenConfiguration.enable_more_details_per_transaction) {
    screens.push(accountTransactionDetailsScreen());
    screens.push(confirmAccountTransactionActionScreen());
    screens.push(transactionSuccessScreen(screenConfiguration));
  }
};

export const accountTransactionsScreen = () => {
  const accountTransactions = {
    name: 'accountTransactions',
    template: 'accountTransactions001',
    listElements: [],
  };
  // --- listElements:
  accountTransactions.listElements.push({
    name: 'list1',
    cellElements: [{
      name: 'cell1',
      template: 'accountTransactionCell001',
    }],
  });
  return accountTransactions;
};

export const accountTransactionDetailsScreen = () => ({
  name: 'accountTransactionDetails',
  template: 'accountTransactionDetails001',
  listElements: [{
    name: 'list1',
    cellElements: [{
      name: 'cell1',
      template: 'accountTransactionDetailsCell001',
    }],
  }],
});

export const confirmAccountTransactionActionScreen = () => ({
  name: 'confirmAccountTransactionAction',
  template: 'confirmAccountTransactionAction001',
});

export const transactionSuccessScreen = (screenConfiguration) => {
  const transactionDetails = {
    name: 'transactionSuccess',
    template: 'transactionSuccess001',
    imageElements: [
      {
        name: 'image1',
        asset: keyboardImagesNames.ic_success,
      },
    ],
  };
  if (screenConfiguration.show_link_transactions_list) {
    transactionDetails.buttonElements = ([{
      name: 'button3',
      actionPath: 'accountBalancePath',
    }]);
  }
  return transactionDetails;
};

export const addConfirmationSplitScreens = (screens) => {
  screens.push({
    name: 'splitPaymentConfirmation',
    template: 'splitPaymentConfirmation001',
  });
};

const getScreenByStepKey = {
  recipient: addSelectRecipientScreens,
  operator: addOperatorScreens,
  amount_package: addAmountPackageScreens,
  amount: addAmountScreens,
  source: addBalanceScreens,
  number: installmentsNumberInputScreen,
  option: selectPackageScreens,
  reference: addReferenceScreens,
  confirmation: addConfirmationScreens,
  order_authentication: addAuthenticationScreens,
  success: addSuccessScreens,
  select_bill: addSelectBillScreens,
  confirmation_bill: addConfirmationBillScreens,
  balance: addBalanceScreens,
  transactions: addTransactionsScreens,
  confirmation_split: addConfirmationSplitScreens,
};
